import { render, staticRenderFns } from "./AddFollowupReply.vue?vue&type=template&id=285411e4&scoped=true"
import script from "./AddFollowupReply.vue?vue&type=script&lang=js"
export * from "./AddFollowupReply.vue?vue&type=script&lang=js"
import style0 from "./AddFollowupReply.vue?vue&type=style&index=0&id=285411e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285411e4",
  null
  
)

export default component.exports